import { Turbo } from "@hotwired/turbo-rails"
import { formatUtcDateForParam } from "../shared/date"

export function openRiesterDetail({ url, zeitpunktUtcMs, anzeigeformat, chartType, frameId }) {
	const datumString = formatUtcDateForParam(zeitpunktUtcMs)
	const params = new URLSearchParams({ zeitpunkt: datumString, chart_type: chartType, anzeigeformat: anzeigeformat })
	const fullUrl = `${url}?${params.toString()}`

	if (frameId) {
		Turbo.visit(fullUrl, { frame: frameId })
		return
	}

	Turbo.visit(fullUrl)
}
